import React from "react"
import { VictoryLabel } from "victory"
import PropTypes from "prop-types"

export const Title = ({ width }) => {
  return (
    <VictoryLabel
      className="Title"
      text="USAGE SNAPSHOT"
      dx={width / 2}
      dy={20}
      style={{
        fontSize: 12,
        textAnchor: "middle",
      }}
    />
  )
}

Title.propTypes = { width: PropTypes.number }

export const PercentUsage = () => {
  return (
    <VictoryLabel
      className="PercentUsage"
      text=""
      dx={17}
      dy={30}
      style={{
        fontSize: 10,
        textAnchor: "start",
      }}
    />
  )
}

export const NotEnoughData = ({ width, height }) => {
  return (
    <VictoryLabel
      className="NotEnoughData"
      text="Not enough data. Try increasing your date range."
      x={width / 2}
      y={height / 2 - 10}
      textAnchor={"middle"}
      style={{ fontSize: "18px", fill: "#999999" }}
    />
  )
}

NotEnoughData.propTypes = { width: PropTypes.number, height: PropTypes.number }
